import { render, staticRenderFns } from "./wingFlight.vue?vue&type=template&id=7ca9f44b&scoped=true&"
import script from "./wingFlight.vue?vue&type=script&lang=js&"
export * from "./wingFlight.vue?vue&type=script&lang=js&"
import style0 from "./wingFlight.vue?vue&type=style&index=0&id=7ca9f44b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca9f44b",
  null
  
)

export default component.exports